{
	"title": "Beschikbare materialen",
	"showAllTitle": "Alle materialen tonen",
	"table": {
		"material": "Materiaal",
		"invoicedQuantity": "Gefactureerde hoeveelheid",
		"remainingForTransfer": "Resterend voor het aanmaken van een verklaring",
		"fetchError": "Materialen konden niet worden opgehaald",
		"noMaterials": {
			"title": "Geen materialen beschikbaar",
			"description": "U heeft momenteel geen materialen beschikbaar op {{productName}}. Neem contact op met uw salescontactpersoon om uw contract(en) aan uw account toe te voegen."
		}
	}
}
